import Card from "../Card"
import { useAppSelector } from "../../redux/store/hooks"
import {
    getDashboardQuestionnaireId,
    getDashboardQuestionnaireType
} from "../../redux/ProfessionalDashboard"
import notNull from "../../util/notNull"
import SmallHeadingComponent from "../SmallHeadingComponent"
import { useEffect, useState } from "react"
import {
    FetchSingleQuestionnaireResponsePayload,
    FetchSingleQuestionnaireSpecification,
    PHQ8_ANSWER_COLOR,
    PHQ8_ANSWERS,
    PHQ8_PREQUESTION,
    PHQ8_QUESTIONS,
    SFQ_ANSWER_COLOR,
    SFQ_PRE_QUESTION,
    SFQ_QUESTIONS,
    ValueType
} from "pokal_api"
import PokalColorConverter from "../../util/PokalColorConverter"

function QuestionnaireDetailView() {
    const questionnaireType = useAppSelector(getDashboardQuestionnaireType)
    const questionnaireId = useAppSelector(getDashboardQuestionnaireId)

    const [fetched, setFetched] =
        useState<FetchSingleQuestionnaireResponsePayload | null>(null)

    useEffect(() => {
        if (notNull(questionnaireId) && notNull(questionnaireType)) {
            FetchSingleQuestionnaireSpecification.request({
                questionnaire: questionnaireId,
                type: questionnaireType
            }).then((res) => setFetched(res))
        }
    }, [questionnaireType, questionnaireId])

    useEffect(() => {
        console.log(SFQ_QUESTIONS.length)
        console.log(fetched)
    }, [fetched])

    function phq() {
        return questionnaireType === ValueType.PHQUESTIONNAIRE
    }

    const isSFQ = questionnaireType === ValueType.SFQUESTIONNAIRE;

    // Nur anzeigen, wenn ein Eintrag ausgewählt ist
    if (!notNull(questionnaireType) || !notNull(questionnaireId) || !notNull(fetched)) {
        return null;
    }

    // Datum/Uhrzeit für große Anzeige
    const entryDate = fetched.date ? new Date(fetched.date) : null;

    return (
        <Card fill={true}>
            <div className="flex flex-col space-y-4 overflow-y-scroll max-h-[380px] h-full">
                <SmallHeadingComponent>Fragebogen-Detail</SmallHeadingComponent>
                {entryDate && (
                    <div className="text-2xl font-bold text-blue-800 mb-2">
                        {entryDate.toLocaleDateString("de-DE", { year: 'numeric', month: '2-digit', day: '2-digit' })}
                        {" um "}
                        {entryDate.toLocaleTimeString("de-DE", { hour: '2-digit', minute: '2-digit' })}
                    </div>
                )}
                <div className={"font-bold"}>{phq() ? PHQ8_PREQUESTION : SFQ_PRE_QUESTION}</div>
                <div className={"flex flex-col space-y-4"}>
                    {phq() ? (
                        PHQ8_QUESTIONS.map((q, index) => (
                            <div key={index} className={"flex items-center"}>
                                <div className={"flex-2 uppercase text-[10px]"}>{q}</div>
                                <div className={`${PokalColorConverter.toBadge(PHQ8_ANSWER_COLOR(fetched.answers[index]))} flex-1`}>
                                    {PHQ8_ANSWERS[fetched.answers[index]]}
                                </div>
                            </div>
                        ))
                    ) : (
                        SFQ_QUESTIONS.map((q, index) => (
                            <div key={index} className={"flex items-center"}>
                                <div className={"flex-2 uppercase text-[10px]"}>{q.question}</div>
                                <div className={`${PokalColorConverter.toBadge(
                                    SFQ_ANSWER_COLOR(
                                        q,
                                        index < fetched.answers.length
                                            ? fetched.answers[index]
                                            : 0
                                    )
                                )} flex-1`}>
                                    {q.answers[fetched.answers[index]]}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </Card>
    );
}

export default QuestionnaireDetailView
